export const CDP_HYDRATE_CHARGE = 'cdp_hydrateCharge';
export const CDP_CREATE_PRODUCT_CHARGE = 'cdp_createProductCharge';
